import { FC, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { FormInput } from "@/shared/ui/form-input";
import notify from "@/shared/lib/notify";
import { getErrorMessage } from "@/shared/consts/error-codes";
import { useAppDispatch } from "@/shared/lib/redux";
import { fetchCreateWhitelistEntry, fetchWhitelistedPhones } from "../../model";

interface AddPhoneFormData {
    phone: string;
}

export const AddPhoneForm: FC = () => {
    const dispatch = useAppDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const {
        handleSubmit,
        register,
        reset,
        formState: { errors }
    } = useForm<AddPhoneFormData>();

    const onSubmit: SubmitHandler<AddPhoneFormData> = async (data) => {
        setIsSubmitting(true);
        try {
            await dispatch(fetchCreateWhitelistEntry({ phone: data.phone })).unwrap();
            notify.success('Телефон успешно добавлен в белый список');
            reset();
            dispatch(fetchWhitelistedPhones());
        } catch (error: any) {
            notify.error(getErrorMessage(error));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="box !h-full">
            <div className="box_header !mb-2 font-mediumttf">
                Добавить телефон
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
                <div className="flex-1">
                    <FormInput
                        register={register as any}
                        id="phone"
                        label="Телефон"
                        type="text"
                        required
                        placeholder="+79999999999"
                        error={errors.phone}
                    />
                </div>
                <button
                    className="form_handle_button"
                    disabled={isSubmitting}
                    type="submit"
                >
                    Добавить
                </button>
            </form>
        </div>
    );
};

